import { GET_MY_NETWORK } from '../actions/types'

const initialState = {
  list: []
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_MY_NETWORK:
      return { ...state, list: action.payload }
    default:
      return state
  }
}